import { useNavigate } from 'react-router-dom';

import { CustomButton, Text } from '../shared/uiComponents';
import Wrapper from '../components/WrapperWithoutMenu';
import { CheckboxWrapper } from '../components/StyledComponents';

const Component = () => {
	const navigate = useNavigate();

	const goBack = () => navigate(-1);

	return (
		<CheckboxWrapper>
			<Text title="Page not found" type="lg" font="header" fontWeight="semiBold" className="marginBottom24" />
			<CustomButton title="Go back" onClick={goBack} />
		</CheckboxWrapper>
	);
};

const NotFound = () => <Wrapper Component={Component} />;

export default NotFound;
